import React from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import * as Sentry from '@sentry/browser';

export const PaymentStatus = () => {
  const stripe = useStripe();
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    if (!stripe) {
      return;
    }

    // Retrieve the "payment_intent_client_secret" query parameter appended to your return_url by Stripe.js
    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');

    // Retrieve the PaymentIntent
    try {
      stripe
        .retrievePaymentIntent(clientSecret ? clientSecret : '')
        .then(({ paymentIntent }) => {
          // Inspect the PaymentIntent `status` to indicate the status of the payment to your customer.
          // Some payment methods will [immediately succeed or fail][0] upon confirmation, while others will first enter a `processing` state.
          // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification

          if (!paymentIntent) {
            setMessage('No payment intent found.');
            return;
          }
          switch (paymentIntent.status) {
            case 'succeeded':
              setMessage('Success! Payment received.');
              break;

            case 'processing':
              setMessage("Payment processing. We'll update you when payment is received.");
              break;

            case 'requires_payment_method':
              // Redirect your user back to your payment page to attempt collecting
              // payment again
              setMessage('Payment failed. Please try another payment method.');
              break;

            default:
              setMessage('Something went wrong.');
              break;
          }
        })
        .catch((error) => {
          Sentry.captureException(error);
          console.error('Error handling payment intent', error);
          setMessage('An error occurred during payment processing. Please contact support.');
        });
    } catch (error) {
      Sentry.captureException(error);
      console.error('Error retrieving payment intent', error);
      setMessage('Payment error. Please contact support.');
    }
  }, [stripe]);

  return message;
};
